<template>
    <div>
        <el-form label-position="top">
            <el-form-item label="学生名">
                <el-select v-model="student_id" clearable placeholder="请选择学生姓名" filterable remote
                           :remote-method="handleSearchStudentName"
                          >
                    <el-option
                            v-for="item in $parentInfo.students"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-button @click="handleAddTeam()" :loading="$parentInfo.Dialogs_TeamAddStudent.button_loading">加入</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        name: "Dialogs_TeamAddStudent",
        data() {
            return {
                loading: true,
                student_id :'',
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handleAddTeam() {
                this.$parentInfo.Dialogs_TeamAddStudent.button_loading=true;
                this.$wApi.send(this.$parentInfo.path, 'go_into_team', {
                    'student_id':this.student_id,
                    'team_id': this.$store.state.modal.data.team_id,
                })
            },
            handleSearchStudentName(query){
                this.$wApi.send(this.$parentInfo.path, 'search', {
                    'type':'studentKeyName',
                    'studentKeyName': query,
                })
            },
        }
    }
</script>

<style scoped>

</style>